import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export type HighlightColor = NonNullable<Schemas['highlights']['attributes']>['color'];

export const highlightColors = [
    'yellow',
    'orange',
    'green',
    'blue',
    'purple',
    'pink',
] as const satisfies readonly HighlightColor[];

export class Highlight extends Model<Schemas['highlights'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }
}
